import { Skeleton } from 'antd';
import { useDataSheetWrapper } from 'components/layouts/components/data-sheet/wrapper';
import { PropsSetState, TableStyleBasedOnTab, TreeNodeType } from '../types';
import {
  GET_PROJECT_NODE_TYPES_LIST_LEFT_MENU,
  GET_PUBLIC_PROJECT_NODE_TYPES_LIST,
  useGetProjectNoteTypes,
} from 'api/project-node-types/use-get-project-note-types';
import { createNodesTree } from 'components/layouts/components/data-sheet/utils';
import { DataSheetActionKind } from 'components/layouts/components/data-sheet/hooks/data-sheet-manage';
import { NodeTypesView } from './node-types-view';
import { useCallback } from 'react';
import { EventDataNode } from 'antd/es/tree';
import { useParams } from 'react-router-dom';
import { useIsPublicPage } from 'hooks/use-is-public-page';
import { updateTypeParentId } from 'helpers/utils';
import { useGetProjecTPermission } from 'api/project-node-types/use-get-permisson';

type Props = PropsSetState & TableStyleBasedOnTab;

export const NodeTypes = ({ searchVisible, setSearchVisible, isCheckable = false, noColors = false }: Props) => {
  const params = useParams();
  const isPublicPage = useIsPublicPage();

  const { selectNodeType, color, nodeTypeId, selectNodeTypeFinished, allTypeSelected, dispatch } =
    useDataSheetWrapper();

  useGetProjecTPermission(params.id || '', {
    enabled: true,
    onSuccess(data) {
      localStorage.setItem('permissions', JSON.stringify({ data }));
    },
  });

  const {
    formatted: nodesList,
    isInitialLoading,
    data,
  } = useGetProjectNoteTypes(
    {
      url: isPublicPage ? GET_PUBLIC_PROJECT_NODE_TYPES_LIST : GET_PROJECT_NODE_TYPES_LIST_LEFT_MENU,
      projectId: params.id || '',
    },
    {
      enabled: !!(params.id && !!selectNodeType && allTypeSelected !== 2),
      onSuccess: (data) => {
        updateTypeParentId(data?.data);
        /** This condition sets selected fisr node type when first time enter to this page */
        /** WONT work wor all type as the data already exists */
        const nodesList = createNodesTree(data.data, noColors);
        if (data.data.length && !nodeTypeId) {
          selectNodeType?.({
            titleText: data.data[0].name,
            color: data.data[0].color,
            nodeTypeId: data.data[0].id,
            parentId: data.data[0].parent_id || '',
            selectNodeTypeFinished: true,
            nodesList,
            dataList: data.data,
          });
          return;
        }
        selectNodeType?.({
          selectNodeTypeFinished: true,
          nodesList,
        });
      },
    },
    noColors
  );

  const onCheck = useCallback(
    (checkedKeys: string[]) => {
      dispatch({
        type: DataSheetActionKind.ALL_DATA_TYPE_CHECK,
        payload: { allDataTypesList: checkedKeys as string[] },
      });
    },
    [dispatch]
  );

  const onSelect = useCallback(
    (selectedKeys: string[], e: { selected: boolean; node: EventDataNode<TreeNodeType> }) => {
      selectNodeType({
        titleText: e.node.name,
        color: e.node.color,
        nodeTypeId: e.node.id,
        parentId: e.node.parent_id || '',
        selectNodeTypeFinished: true,
        nodesList,
        dataList: data,
      });
    },
    [data, nodesList, selectNodeType]
  );

  return !selectNodeTypeFinished || isInitialLoading ? (
    <Skeleton />
  ) : (
    <NodeTypesView
      onSelect={onSelect}
      onCheck={onCheck}
      nodesList={nodesList}
      searchVisible={searchVisible}
      setSearchVisible={setSearchVisible}
      isCheckable={isCheckable}
      color={color}
      nodeTypeId={nodeTypeId}
    />
  );
};
